import React from 'react';

import { type THtmlBlock } from '@wp-block-builder/blocks/Html';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): THtmlBlock => ({
  id: generateRandomBlockId(),
  type: 'Html',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'normal',
    textAlign: 'left',
    ...style,
  },
  props: { text: '<p>Hello <strong>{{firstName | default: "friend" }}</strong>!</p>' },
  sectionProps: {},
});

export default defineBlockButton<THtmlBlock>({
  label: 'HTML',
  icon: <BlockTypeIcon type="Html" />,
  defaultBlock: () => getDefaultProps({ padding: '16px 24px 16px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
